(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filter-catalog"] && !Shopify.designMode) return;
  try {
    
  function initializeCatalogSections() {
    document.querySelectorAll('[data-filter-catalog]').forEach((root) => {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';
      const findTarget = (hash) => [...root.querySelectorAll('[id]')].find((element) => '#' + element.id === hash);
      const scrollToCategory = () => findTarget(window.location.hash)?.scrollIntoView({ block: 'start', behavior: 'auto' });
      document.addEventListener('click', (event) => {
        if (!root.isConnected) return;
        const link = event.target.closest('a.pillhead-product-group__link');
        if (!link) return;
        const url = new URL(link.href);
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
        const target = findTarget(url.hash);
        if (!target) return;
        event.preventDefault();
        history.replaceState(null, '', url);
        target.scrollIntoView({ block: 'start', behavior: 'auto' });
      });
      window.addEventListener('hashchange', scrollToCategory);
      scrollToCategory();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCatalogSections);
  else initializeCatalogSections();
  document.addEventListener('shopify:section:load', initializeCatalogSections);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-return-cta"] && !Shopify.designMode) return;
  try {
    
  function syncProductReturnButtons() {
    const primary = document.getElementById('pdp-default-atc-btn');
    if (!primary) return;
    document.querySelectorAll('[data-product-return-atc]').forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      const sync = () => {
        if (!button.isConnected) {
          observer.disconnect();
          return;
        }
        const label = primary.querySelector('[data-atc-label]');
        button.disabled = primary.disabled;
        button.textContent = label ? label.textContent.trim() : primary.textContent.trim();
      };
      const observer = new MutationObserver(sync);
      observer.observe(primary, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        characterData: true,
        subtree: true
      });
      sync();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncProductReturnButtons);
  } else {
    syncProductReturnButtons();
  }
  document.addEventListener('shopify:section:load', syncProductReturnButtons);

  } catch(e) { console.error(e); }
})();
})();
